import { validatePassword } from 'lib/helpers';
import * as yup from 'yup';

const setErrorMessage = (fieldName: string, message: string) => (
    context: yup.TestContext,
) =>
    context.createError({
        path: fieldName,
        message,
    });

const setPasswordErrorMessage = (message: string) => (
    context: yup.TestContext,
) => setErrorMessage('password', message)(context);

export function passwordTest(passwordValue = '') {
    const emailValue = this.parent.email;
    const passwordValidateOptions = { minLength: 8 };

    if (emailValue.endsWith('ua.nestle.com')) {
        passwordValidateOptions.minLength = 16;
    } else if (
        emailValue.endsWith('ua.bosch.com') ||
        emailValue.endsWith('boschrexroth.com.ua') ||
        emailValue.endsWith('bosch.com')
    ) {
        passwordValidateOptions.minLength = 12;
    }

    const errorMessage = validatePassword(
        passwordValue,
        passwordValidateOptions,
    );

    if (errorMessage) {
        return setPasswordErrorMessage(errorMessage)(this);
    }

    return true;
}
